import { create } from "zustand";
import { useAuthStore } from "./auth/store";
import { isSupabaseConfigured } from "./supabase/client";

type PilotState = {
  status: "unresolved" | "ready" | "unavailable";
  ready: boolean;
  assigned: boolean;
  userId: string | null;
  assignmentId: string | null;
};
const LOCAL = !isSupabaseConfigured && !import.meta.env.PROD;
const initial: PilotState = { status: LOCAL ? "ready" : "unresolved", ready: LOCAL, assigned: false, userId: null, assignmentId: null };
export const useSubscriptionPilotStore = create<PilotState>(() => ({ ...initial }));

export function setSubscriptionPilot(status: PilotState["status"], assigned = false, assignmentId: string | null = null): void {
  useSubscriptionPilotStore.setState({ status, ready: status === "ready", assigned,
    userId: useAuthStore.getState().user?.id ?? null, assignmentId });
}
function forAccount(state: PilotState, userId: string | null): PilotState {
  return state.userId === userId || LOCAL ? state : { ...state, status: "unresolved", ready: false, assigned: false };
}
export function getSubscriptionPilot(): PilotState {
  return forAccount(useSubscriptionPilotStore.getState(), useAuthStore.getState().user?.id ?? null);
}
export function useSubscriptionPilot(): PilotState {
  const state = useSubscriptionPilotStore();
  const userId = useAuthStore((auth) => auth.user?.id ?? null);
  return forAccount(state, userId);
}
